<template>
  <div v-if="dataIsLoad && firstOotd.length">
    <div class="product-ootd">
      <h4>#365dayswithpazzo</h4>
      <slick
        ref="slick"
        :options="defaultOptions"
        class="product-photos__slider"
        @afterChange="handleAfterChange"
        @beforeChange="handleBeforeChange"
      >
        <div v-for="(item, index) in firstOotd" :key="item + index">
          <a v-if="!/(blank)/.test(item)" @click="zoomImg($event, index)">
            <i
              v-if="item.VideoUrl"
              class="icon-play d-md-inline-block d-none"
              style="
                position: absolute;
                top: 50%;
                left: 50%;
                margin-top: -20px;
                margin-left: -20px;
                background-size: 40px;
                z-index: 1;
              "
            />
            <i
              v-if="item.VideoMUrl"
              class="icon-play d-md-none d-inline-block"
              style="
                position: absolute;
                top: 50%;
                left: 50%;
                margin-top: -20px;
                margin-left: -20px;
                background-size: 40px;
                z-index: 1;
              "
            />
            <new-image :url="item.Url" :size="'_w886_h1128'" />
          </a>
          <span v-else>
            <img :src="item" />
          </span>
        </div>
      </slick>
    </div>
    <a
      v-if="(firstOotd.length > 3 && isMobile) || (firstOotd.length > 4 && !isMobile)"
      class="btn-more-shop"
    >
      <a class="shop-arrow-left">
        <img
          class="img-fluid"
          src="https://static.tpx.tw/sff/pazzo/static/img/shop-left-arrow.svg"
        />
      </a>
      <span>MORE</span>
      <a class="shop-arrow-right">
        <img
          class="img-fluid"
          src="https://static.tpx.tw/sff/pazzo/static/img/shop-right-arrow.svg"
        />
      </a>
    </a>
  </div>
</template>

<script>
import zoombox from '@global/components/product_vue/zoombox';
import NewImage from '@global/components/global/image';
import Slick from '@global/vendors/vue-slick.vue';
import setEnv from '@global/helpers/setEnv';
import { mapState } from 'vuex';

export default {
  name: 'OOTD',
  components: {
    Slick,
    NewImage,
  },
  data() {
    return {
      defaultOptions: {
        centerMode: false,
        infinite: true,
        slidesToShow: 5,
        slidesToScroll: 4,
        arrows: true,
        dots: false,
        speed: 800,
        prevArrow: '.shop-arrow-left',
        nextArrow: '.shop-arrow-right',
        responsive: [
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 4,
              slidesToScroll: 3,
              arrows: true,
              dots: false,
            },
          },
        ],
      },
      isMobile: setEnv.myEquipment(),
      nowSlick: false,
    };
  },
  computed: {
    ...mapState('shopContent', ['dataIsLoad', 'itemDatas']),
    firstOotd() {
      const firstOotd = this.itemDatas.Colors[0].Images.filter((image) => image.Category === 10);
      if (firstOotd.length === 5 && !this.isMobile) {
        firstOotd.push(firstOotd[2]);
      }
      if (firstOotd.length === 4 && this.isMobile) {
        firstOotd.push(firstOotd[1]);
      }
      return firstOotd;
    },
  },
  methods: {
    zoomImg(event, index) {
      if (this.nowSlick) return;
      const ootdArray = [];

      this.firstOotd.forEach((ele) => {
        const videoUrl = this.isMobile ? ele.VideoMUrl : ele.VideoUrl;
        ootdArray.push(videoUrl !== undefined && videoUrl.length !== 0 ? videoUrl : ele.Url);
      });

      zoombox({
        images: ootdArray,
        index,
        zbClass: 'zb-ootd',
        tilting: true,
      });
    },
    handleAfterChange(event, slick, currentSlide) {
      this.nowSlick = false;
    },
    handleBeforeChange(event, slick, currentSlide, nextSlide) {
      this.nowSlick = true;
    },
  },
};
</script>
